import { useState, useEffect } from 'react';

const LAUNCH_DATE = new Date('2026-05-22T00:00:00+05:30');

const CALENDAR_URL =
  'https://calendar.google.com/calendar/render?action=TEMPLATE' +
  '&text=VerdeMobility+Product+Launch' +
  '&dates=20250507T183000Z/20250507T193000Z' +
  '&details=VerdeMobility+EV+Charger+Launch+Reveal' +
  '&location=verdemobility.com';

function pad(n) {
  return String(n).padStart(2, '0');
}

function getTimeLeft() {
  const diff = LAUNCH_DATE - new Date();
  if (diff <= 0) return { days: 0, hours: 0, mins: 0, secs: 0 };
  return {
    days: Math.floor(diff / 86400000),
    hours: Math.floor((diff % 86400000) / 3600000),
    mins: Math.floor((diff % 3600000) / 60000),
    secs: Math.floor((diff % 60000) / 1000),
  };
}

function UnitBlock({ value, label, showColon }) {
  return (
    <div className="flex items-start ">
      <div className="flex flex-col items-center px-2 xs:px-4 sm:px-6 md:px-8">
        <span
          className="font-['Bebas_Neue'] leading-none tracking-wide text-white text-center
                     text-[36px] xs:text-[44px] sm:text-[56px] md:text-[72px] lg:text-[80px]
                     min-w-[44px] xs:min-w-[56px] sm:min-w-[72px] md:min-w-[90px] lg:min-w-[100px]"
        >
          {pad(value)}
        </span>
        <span
          className="mt-1.5 sm:mt-2 uppercase text-white/65 tracking-[2px] sm:tracking-[3px]
                         text-[7px] xs:text-[8px] sm:text-[9px]"
        >
          {label}
        </span>
      </div>

      {showColon && (
        <span
          className="font-['Bebas_Neue'] leading-none text-white/45 select-none animate-colon-blink
                     text-[32px] xs:text-[40px] sm:text-[48px] md:text-[56px]
                     mt-0.5 sm:mt-1"
        >
          :
        </span>
      )}
    </div>
  );
}

export default function CountdownTimer() {
  const [time, setTime] = useState(getTimeLeft());

  useEffect(() => {
    const id = setInterval(() => setTime(getTimeLeft()), 1000);
    return () => clearInterval(id);
  }, []);

  return (
    <section
      className="w-full border-t border-b border-white/20 lg:mt-[80px] mt-[60px]"
      style={{
        backgroundImage: 'linear-gradient(-190deg, #02ddb7 15%, #03d077 50%)',
      }}
    >
      <div
        className="max-w-6xl mx-auto px-4 sm:px-8 md:px-12 py-4 sm:py-14 md:py-8
                      flex flex-col items-center"
      >
        {/* ── Label ── */}
        <p
          className="uppercase text-white/75 mb-3 sm:mb-3
                      text-sm sm:text-[20px] tracking-[4px] sm:tracking-[5px] "
        >
          Launching in
        </p>

        {/* ── Countdown digits ── */}
        <div className="flex items-start">
          <UnitBlock value={time.days} label="Days" showColon />
          <UnitBlock value={time.hours} label="Hours" showColon />
          <UnitBlock value={time.mins} label="Minutes" showColon />
          <UnitBlock value={time.secs} label="Seconds" showColon={false} />
        </div>

        {/* ── Date note ──
        <p className="mt-5 sm:mt-7 text-white/70 tracking-wide text-center
                      text-[10px] sm:text-xs px-4">
          Reveal at{' '}
          <span className="text-white font-semibold block xs:inline mt-0.5 xs:mt-0">
            12:00 AM IST · Thursday, May 8, 2026
          </span>
        </p> */}

        {/* ── Calendar CTA ── */}

        <a
          href={CALENDAR_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="mt-5 sm:mt-6 inline-flex items-center gap-2
                     px-4 sm:px-5 py-2.5 sm:py-3
                     border border-white/50 rounded-sm bg-white/15
                     text-white font-medium uppercase
                     text-[10px] sm:text-xs tracking-[1.5px]
                     hover:bg-white/28 hover:border-white transition-all duration-200
                     whitespace-nowrap"
        >
          <svg
            className="w-3 h-3 sm:w-3.5 sm:h-3.5 flex-shrink-0"
            viewBox="0 0 16 16"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.5"
          >
            <rect x="2" y="3" width="12" height="12" rx="2" />
            <path d="M5 1v3M11 1v3M2 7h12" />
          </svg>
          Add to Calendar
        </a>
      </div>
    </section>
  );
}
